import {includes} from 'lodash';
import {CONTRACT_TABLE_FILTERS_STATUSES_MAP} from '../constants/contract-table-filters.constants';

export function isFilterStatus(
  value?: string | number | Date | null,
): value is keyof typeof CONTRACT_TABLE_FILTERS_STATUSES_MAP {
  if (typeof value !== 'string') return false;
  return includes(Object.keys(CONTRACT_TABLE_FILTERS_STATUSES_MAP), value);
}
